import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "size", "icon"];
import * as React from 'react';
import cx from 'classnames';
import { getRoundButtonTheme } from '../../themes';
import * as styles from '../../styles/roundButton.css';

/**
 * Компонент круглой кнопки с иконкой. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать иконки. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 */
var RoundButtonComponent = /*#__PURE__*/React.forwardRef(function RoundedButton(props, ref) {
  var theme = props.theme,
    size = props.size,
    icon = props.icon,
    rest = _objectWithoutProperties(props, _excluded);
  var themeClasses = getRoundButtonTheme(theme);
  var buttonClasses = cx(styles['button'], styles[size], themeClasses['button']);
  var preparedIcon = /*#__PURE__*/React.cloneElement(icon, {
    color: 'currentColor'
  });
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: buttonClasses,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, preparedIcon));
});
RoundButtonComponent.defaultProps = {
  theme: 'fill_light',
  size: 'M'
};
export var RoundButton = /*#__PURE__*/React.memo(RoundButtonComponent);